export const translations = {
  en: {
    // Landing Page
    landing: {
      title: 'IN — Inner Navigation',
      subtitle: 'See where you are in life. Understand where you\'re stuck. Know what to focus on next.',
      cta: 'Begin Your Journey',
      howItWorks: 'The Journey',
      step1Title: '1. Map Your Life',
      step1Desc: 'Answer 12 questions across physical, work, relationships, and inner world. See your life as a visual Sun Map.',
      step2Title: '2. Receive Guidance',
      step2Desc: 'Get personalized insights combining Jungian psychology and archetypal wisdom tailored to your unique journey.',
      step3Title: '3. Track Progress',
      step3Desc: 'Weekly check-ins reveal your momentum. Watch your Sun Map evolve as you grow.',
      philosophy: '"People are not lost because they lack information. People are lost because they lack orientation."',
      philosophyDesc: 'IN provides clarity, direction, and momentum for your life journey.',
    },
    // Auth Page
    auth: {
      welcomeBack: 'Welcome Back',
      beginJourney: 'Begin Your Journey',
      name: 'Name',
      email: 'Email',
      password: 'Password',
      signIn: 'Sign In',
      createAccount: 'Create Account',
      needAccount: 'Need an account? Sign up',
      haveAccount: 'Already have an account? Sign in',
      pleaseWait: 'Please wait...',
      authFailed: 'Authentication failed',
    },
    // IN-Take
    intake: {
      title: 'IN-Take',
      subtitle: 'Help us personalize your journey',
      age: 'Age',
      agePlace: 'Your age',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      nonBinary: 'Non-binary',
      other: 'Other',
      selectGender: 'Select...',
      relationshipStatus: 'Relationship Status',
      single: 'Single',
      relationship: 'In a relationship',
      married: 'Married',
      divorced: 'Divorced',
      widowed: 'Widowed',
      itsComplicated: "It's complicated",
      relationshipOther: 'Other',
      selectRelationship: 'Select...',
      children: 'Do you have children?',
      yes: 'Yes',
      no: 'No',
      country: 'Country / Culture',
      countryPlace: 'e.g., United States, India, Brazil...',
      workType: 'Work Type',
      student: 'Student',
      employed: 'Employed',
      entrepreneur: 'Entrepreneur',
      freelance: 'Freelance',
      unemployed: 'Unemployed / Between jobs',
      retired: 'Retired',
      caregiver: 'Caregiver / Homemaker',
      selectWork: 'Select...',
      worldview: 'Which of these best describes how you understand life and the universe?',
      worldviewDesc: 'This helps us speak in language that resonates with you',
      religious: 'Religious',
      religiousDesc: 'God / scripture based',
      spiritual: 'Spiritual',
      spiritualDesc: 'energy / consciousness / inner path',
      scientific: 'Scientific',
      scientificDesc: 'evidence / reason / material world',
      philosophical: 'Philosophical',
      philosophicalDesc: 'meaning / ethics / ideas',
      humanistic: 'Humanistic',
      humanisticDesc: 'people / society / progress',
      exploring: 'Unsure / still exploring',
      exploringDesc: '',
      worldviewOther: 'Other / In your own words',
      worldviewOtherDesc: '',
      continue: 'Continue to Assessment',
      saving: 'Saving...',
      profileSaved: 'Profile saved!',
      failedSave: 'Failed to save profile',
    },
    // Assessment
    assessment: {
      title: 'Life Assessment',
      subtitle: 'Rate each area of your life from 1 (very poor) to 10 (excellent)',
      metaTitle: 'Life Direction',
      metaSubtitle: 'These questions reveal your trajectory, not just your status',
      writtenTitle: 'Your Story',
      writtenSubtitle: 'These reflections help the AI understand your unique journey',
      continue: 'Continue',
      back: 'Back',
      generating: 'Generating Your Sun Map...',
      generate: 'Generate Sun Map',
      sharePlaceholder: 'Share your thoughts...',
      success: 'Your Sun Map has been generated!',
      failed: 'Failed to create assessment',
      // Core questions
      physicalHealth: 'Physical Health',
      physicalHealthQ: 'How healthy do you feel your body is right now?',
      strengthFitness: 'Strength / Fitness',
      strengthFitnessQ: 'How physically strong and capable do you feel?',
      energy: 'Energy',
      energyQ: 'How is your daily energy level and vitality?',
      environmentOrder: 'Environment / Order',
      environmentOrderQ: 'How organized and supportive is your living and working environment?',
      workMission: 'Work / Mission',
      workMissionQ: 'How meaningful and aligned is your work or main activity?',
      moneyFinancial: 'Money / Financial Stability',
      moneyFinancialQ: 'How stable and under control are your finances?',
      loveRelationship: 'Love / Relationship',
      loveRelationshipQ: 'How satisfied are you with your romantic life or love life?',
      friendsCommunity: 'Friends / Community',
      friendsCommunityQ: 'How strong is your social life and sense of community?',
      emotionalStability: 'Emotional Stability',
      emotionalStabilityQ: 'How emotionally stable and balanced do you feel?',
      disciplineConsistency: 'Discipline / Consistency',
      disciplineConsistencyQ: 'How consistent are you in doing what you know you should do?',
      learningGrowth: 'Learning / Growth',
      learningGrowthQ: 'Are you learning, growing, and developing yourself?',
      meaningPurpose: 'Meaning / Purpose',
      meaningPurposeQ: 'Do you feel your life has direction and meaning?',
      // Meta questions
      direction: 'Direction',
      directionQ: 'Do you feel clear about where your life is going?',
      alignment: 'Alignment',
      alignmentQ: 'Are your daily actions aligned with the life you want?',
      momentum: 'Momentum',
      momentumQ: 'Do you feel you are moving forward or stuck?',
      stressOverwhelm: 'Stress / Overwhelm',
      stressOverwhelmQ: 'How overwhelmed or stressed do you feel?',
      // Written questions
      buildingAchieving: 'What are you currently trying to build or achieve in your life?',
      biggestProblem: 'What is your biggest problem or challenge right now?',
      mostStuck: 'What area of your life feels most stuck?',
      goingWell: 'What area of your life is going well?',
      avoiding: 'What do you know you should be doing but are avoiding?',
      oneYearDifferent: 'If your life improved a lot in one year, what would be different?',
      anythingElse: 'Anything else you want IN — Inner Navigation to know about your situation?',
    },
    // Dashboard
    dashboard: {
      title: 'Your Inner Navigation',
      greeting: 'Welcome back',
      assessmentFrom: 'Assessment from',
      lifeDirectionMetrics: 'Life Direction Metrics',
      todaysFocus: "Today's Focus",
      quickActions: 'Quick Actions',
    },
    // Dashboard & Navigation
    nav: {
      aiCoach: 'AI Coach',
      theINN: 'The INN',
      integrate: 'INtegrate',
      goals: 'Goals',
      morning: 'Morning',
      evening: 'Evening',
      progress: 'Progress',
      settings: 'Settings',
      logout: 'Logout',
      dashboard: 'Dashboard',
      back: 'Back',
      backToDashboard: 'Back to Dashboard',
    },
    // Morning Guidance
    morning: {
      title: 'Good Morning',
      subtitle: 'Here\'s your guidance for today',
      mantraTitle: 'Daily Mantra',
      todayFocus: 'Today\'s Focus',
      actionableSteps: 'Actionable Steps',
      yourSunMap: 'Your Sun Map',
      goToDashboard: 'Go to Dashboard',
      failed: 'Failed to load morning guidance',
    },
    // Evening Check-In
    evening: {
      title: 'Evening Check-IN',
      subtitle: 'Reflect on today and set intentions for tomorrow',
      winsLabel: 'What were your wINs today?',
      winsHint: 'Celebrate your progress, no matter how small',
      winsPlaceholder: 'I showed up, I tried, I learned...',
      improveLabel: 'What could you do better tomorrow?',
      improveHint: 'Growth happens in honest reflection',
      improvePlaceholder: 'Tomorrow I will focus on...',
      submit: 'Complete Check-IN',
      submitting: 'Reflecting...',
      restWell: 'Rest well. Tomorrow is a new chapter.',
      returnDashboard: 'Return to Dashboard',
      saved: 'Evening check-in saved!',
      failed: 'Failed to save check-in',
    },
    // Coaching
    coaching: {
      title: 'Your AI Coach',
      welcomeMessage: "I'm your AI coach. I know your priorities, habits, and progress. Ask me anything about your goals, or tell me what's on your mind.",
      placeholder: 'Ask me about your goals, progress, or next steps...',
      errorResponse: "I'm having trouble connecting. Please try again.",
      failed: 'Failed to get response',
    },
    // Weekly Goals Check-In
    goalsCheckin: {
      title: 'Weekly Goals Check-In',
      subtitle: 'Track your progress on your specific priorities and habits',
      prioritiesTitle: 'Your 3 Priorities - Rate Your Progress (0-100)',
      notesPlaceholder: 'Notes on progress or blockers...',
      habitsTitle: 'Your 3 Weekly Habits - Did You Complete Them?',
      saveProgress: 'Save Progress',
      saving: 'Saving...',
      success: 'Weekly check-in complete!',
      failed: 'Failed to save check-in',
      loadFailed: 'Failed to load goals',
    },
    // Check-In (Weekly)
    checkin: {
      title: 'Weekly Check-In',
      subtitle: 'Re-score each area to track your progress',
      reflectionLabel: 'Weekly Reflection (Optional)',
      reflectionPlaceholder: 'What changed this week? Any insights?',
      complete: 'Complete Check-In',
      updating: 'Updating...',
      success: 'Weekly check-in complete!',
      failed: 'Failed to submit check-in',
    },
    // Progress
    progress: {
      title: 'Your Progress Journey',
      assessmentsCompleted: 'assessment completed',
      assessmentsCompletedPlural: 'assessments completed',
      chartTitle: 'Key Domains Over Time',
      historyTitle: 'Assessment History',
      initialAssessment: 'Initial Assessment',
      weeklyCheckin: 'Weekly Check-In',
      failed: 'Failed to load progress history',
    },
    // Settings
    settings: {
      title: 'Daily Check-IN Settings',
      morningTitle: 'Morning Sun Map Reminder',
      morningDesc: 'Get your daily focus, actionable steps, and personalized mantra',
      morningTime: 'Morning Time',
      eveningTitle: 'Evening Check-IN',
      eveningDesc: 'Reflect on your wINs and set intentions for tomorrow',
      eveningTime: 'Evening Time',
      notificationMethod: 'Notification Method',
      inApp: 'In-App',
      email: 'Email',
      both: 'Both',
      savePreferences: 'Save Preferences',
      saving: 'Saving...',
      saved: 'Preferences saved!',
      failed: 'Failed to save preferences',
    },
    // INtegrate
    integrate: {
      title: 'INtegrate',
      subtitle: 'Connect your apps to automatically track progress across your Sun Map domains',
      connectedApps: 'Connected Apps',
      tracks: 'Tracks',
      comingSoon: 'Coming Soon',
      connect: 'Connect',
      disconnect: 'Disconnect',
      connectFailed: 'Failed to connect app',
      disconnectFailed: 'Failed to disconnect app',
      disconnected: 'App disconnected',
      placeholder: 'Full OAuth integration coming soon. Current connections are placeholders to demonstrate the feature.',
      loadFailed: 'Failed to load apps',
    },
    // The INN
    inn: {
      title: 'The INN',
      subtitle: 'Curated teachers, practices, and resources for each life domain',
      domains: 'Domains',
      all: 'all',
      book: 'book',
      teacher: 'teacher',
      practice: 'practice',
      course: 'course',
      tool: 'tool',
      learnMore: 'Learn More',
      noResources: 'No resources found for this filter',
      growingLibrary: 'The INN is a growing library. More resources are being added regularly.',
      contribute: 'Want to contribute? Reach out to suggest teachers, practices, or resources.',
      loadFailed: 'Failed to load domains',
      resourcesFailed: 'Failed to load resources',
      recommendedForYou: 'Recommended For You',
      focusAreas: 'Based on your focus areas',
    },
    // Sun Map Component
    sunMap: {
      title: 'Your Sun Map',
      export: 'Export',
      share: 'Share',
      downloadSuccess: 'Sun Map downloaded!',
      downloadFailed: 'Failed to export Sun Map',
      shareSuccess: 'Shared successfully!',
      linkCopied: 'Link copied to clipboard!',
      shareFailed: 'Failed to share',
      solarIdeal: 'Solar Ideal',
      currentPattern: 'Current Pattern',
      previous: 'Previous',
    },
    // AI Guidance Card
    aiGuidance: {
      title: 'Your Inner Guide',
      activeArchetypes: 'Active Archetypes',
      weeklyFocus: "This Week's Focus",
      priorities: '30-Day Priorities',
      weeklyHabits: 'Weekly Habits',
    },
    // Dictation
    dictation: {
      recording: 'Recording...',
      processing: 'Processing...',
      tapToSpeak: 'Tap to speak',
      error: 'Voice input failed',
    },
    // Common
    common: {
      loading: 'Loading...',
      back: 'Back',
      backToDashboard: 'Back to Dashboard',
      save: 'Save',
      cancel: 'Cancel',
      submit: 'Submit',
    },
  },
  tr: {
    // Landing Page
    landing: {
      title: 'IN — İç Navigasyon',
      subtitle: 'Hayatınızda nerede olduğunuzu görün. Nerede sıkıştığınızı anlayın. Neye odaklanmanız gerektiğini bilin.',
      cta: 'Yolculuğa Başla',
      howItWorks: 'Yolculuk',
      step1Title: '1. Hayatınızı Haritalayın',
      step1Desc: 'Fiziksel, iş, ilişkiler ve iç dünya alanlarında 12 soruyu cevaplayın. Hayatınızı görsel bir Güneş Haritası olarak görün.',
      step2Title: '2. Rehberlik Alın',
      step2Desc: 'Jung psikolojisi ve arketipsel bilgeliği birleştiren, benzersiz yolculuğunuza özel kişiselleştirilmiş içgörüler edinin.',
      step3Title: '3. İlerlemenizi Takip Edin',
      step3Desc: 'Haftalık kontroller momentumunuzu ortaya çıkarır. Büyüdükçe Güneş Haritanızın evrimini izleyin.',
      philosophy: '"İnsanlar bilgi eksikliğinden değil, yön eksikliğinden kaybolurlar."',
      philosophyDesc: 'IN, yaşam yolculuğunuz için netlik, yön ve momentum sağlar.',
    },
    // Auth Page
    auth: {
      welcomeBack: 'Tekrar Hoş Geldiniz',
      beginJourney: 'Yolculuğa Başla',
      name: 'İsim',
      email: 'E-posta',
      password: 'Şifre',
      signIn: 'Giriş Yap',
      createAccount: 'Hesap Oluştur',
      needAccount: 'Hesabınız yok mu? Kaydolun',
      haveAccount: 'Zaten hesabınız var mı? Giriş yapın',
      pleaseWait: 'Lütfen bekleyin...',
      authFailed: 'Kimlik doğrulama başarısız',
    },
    // IN-Take
    intake: {
      title: 'IN-Kayıt',
      subtitle: 'Yolculuğunuzu kişiselleştirmemize yardımcı olun',
      age: 'Yaş',
      agePlace: 'Yaşınız',
      gender: 'Cinsiyet',
      male: 'Erkek',
      female: 'Kadın',
      nonBinary: 'Non-binary',
      other: 'Diğer',
      selectGender: 'Seçin...',
      relationshipStatus: 'İlişki Durumu',
      single: 'Bekâr',
      relationship: 'İlişkide',
      married: 'Evli',
      divorced: 'Boşanmış',
      widowed: 'Dul',
      itsComplicated: 'Karmaşık',
      relationshipOther: 'Diğer',
      selectRelationship: 'Seçin...',
      children: 'Çocuğunuz var mı?',
      yes: 'Evet',
      no: 'Hayır',
      country: 'Ülke / Kültür',
      countryPlace: 'örn., Türkiye, Amerika, Hindistan...',
      workType: 'Çalışma Türü',
      student: 'Öğrenci',
      employed: 'Çalışan',
      entrepreneur: 'Girişimci',
      freelance: 'Serbest Çalışan',
      unemployed: 'İşsiz / İşler arası',
      retired: 'Emekli',
      caregiver: 'Bakıcı / Ev hanımı',
      selectWork: 'Seçin...',
      worldview: 'Hayatı ve evreni nasıl anladığınızı en iyi hangisi tanımlar?',
      worldviewDesc: 'Bu, sizinle rezonansa giren bir dilde konuşmamıza yardımcı olur',
      religious: 'Dinî',
      religiousDesc: 'Tanrı / kutsal kitap temelli',
      spiritual: 'Spiritüel',
      spiritualDesc: 'enerji / bilinç / iç yolculuk',
      scientific: 'Bilimsel',
      scientificDesc: 'kanıt / akıl / maddi dünya',
      philosophical: 'Felsefi',
      philosophicalDesc: 'anlam / etik / fikirler',
      humanistic: 'Hümanist',
      humanisticDesc: 'insanlar / toplum / ilerleme',
      exploring: 'Emin değilim / hâlâ keşfediyorum',
      exploringDesc: '',
      worldviewOther: 'Diğer / Kendi kelimelerinle',
      worldviewOtherDesc: '',
      continue: 'Değerlendirmeye Devam Et',
      saving: 'Kaydediliyor...',
      profileSaved: 'Profil kaydedildi!',
      failedSave: 'Profil kaydedilemedi',
    },
    // Assessment
    assessment: {
      title: 'Yaşam Değerlendirmesi',
      subtitle: 'Hayatınızın her alanını 1 (çok kötü) ile 10 (mükemmel) arasında puanlayın',
      metaTitle: 'Yaşam Yönü',
      metaSubtitle: 'Bu sorular sadece durumunuzu değil, yönünüzü ortaya koyar',
      writtenTitle: 'Hikâyeniz',
      writtenSubtitle: 'Bu yansımalar yapay zekânın benzersiz yolculuğunuzu anlamasına yardımcı olur',
      continue: 'Devam',
      back: 'Geri',
      generating: 'Güneş Haritanız Oluşturuluyor...',
      generate: 'Güneş Haritası Oluştur',
      sharePlaceholder: 'Düşüncelerinizi paylaşın...',
      success: 'Güneş Haritanız oluşturuldu!',
      failed: 'Değerlendirme oluşturulamadı',
      // Core questions
      physicalHealth: 'Fiziksel Sağlık',
      physicalHealthQ: 'Şu anda vücudunuzun ne kadar sağlıklı olduğunu hissediyorsunuz?',
      strengthFitness: 'Güç / Fitness',
      strengthFitnessQ: 'Fiziksel olarak kendinizi ne kadar güçlü ve yetenekli hissediyorsunuz?',
      energy: 'Enerji',
      energyQ: 'Günlük enerji seviyeniz ve canlılık durumunuz nasıl?',
      environmentOrder: 'Çevre / Düzen',
      environmentOrderQ: 'Yaşam ve çalışma ortamınız ne kadar düzenli ve destekleyici?',
      workMission: 'İş / Misyon',
      workMissionQ: 'İşiniz veya ana faaliyetiniz ne kadar anlamlı ve uyumlu?',
      moneyFinancial: 'Para / Finansal İstikrar',
      moneyFinancialQ: 'Finanslarınız ne kadar istikrarlı ve kontrol altında?',
      loveRelationship: 'Aşk / İlişki',
      loveRelationshipQ: 'Romantik yaşamınızdan veya aşk hayatınızdan ne kadar memnunsunuz?',
      friendsCommunity: 'Arkadaşlar / Topluluk',
      friendsCommunityQ: 'Sosyal yaşamınız ve topluluk hissiniz ne kadar güçlü?',
      emotionalStability: 'Duygusal İstikrar',
      emotionalStabilityQ: 'Duygusal olarak kendinizi ne kadar istikrarlı ve dengeli hissediyorsunuz?',
      disciplineConsistency: 'Disiplin / Tutarlılık',
      disciplineConsistencyQ: 'Yapmanız gerektiğini bildiğiniz şeyleri yapmakta ne kadar tutarlısınız?',
      learningGrowth: 'Öğrenme / Gelişim',
      learningGrowthQ: 'Öğreniyor, büyüyor ve kendinizi geliştiriyor musunuz?',
      meaningPurpose: 'Anlam / Amaç',
      meaningPurposeQ: 'Hayatınızın bir yönü ve anlamı olduğunu hissediyor musunuz?',
      // Meta questions
      direction: 'Yön',
      directionQ: 'Hayatınızın nereye gittiğini net olarak hissediyor musunuz?',
      alignment: 'Uyum',
      alignmentQ: 'Günlük eylemleriniz istediğiniz yaşam ile uyumlu mu?',
      momentum: 'Momentum',
      momentumQ: 'İleri hareket ettiğinizi mi yoksa sıkışıp kaldığınızı mı hissediyorsunuz?',
      stressOverwhelm: 'Stres / Bunalım',
      stressOverwhelmQ: 'Kendinizi ne kadar bunalmış veya stresli hissediyorsunuz?',
      // Written questions
      buildingAchieving: 'Şu anda hayatınızda neyi inşa etmeye veya başarmaya çalışıyorsunuz?',
      biggestProblem: 'Şu anki en büyük probleminiz veya zorluğunuz nedir?',
      mostStuck: 'Hayatınızın hangi alanı en çok sıkışmış hissettiriyor?',
      goingWell: 'Hayatınızın hangi alanı iyi gidiyor?',
      avoiding: 'Yapmanız gerektiğini bildiğiniz ama kaçındığınız şey nedir?',
      oneYearDifferent: 'Bir yıl içinde hayatınız çok gelişseydi ne farklı olurdu?',
      anythingElse: "IN — İç Navigasyon'un durumunuz hakkında bilmesini istediğiniz başka bir şey var mı?",
    },
    // Dashboard
    dashboard: {
      title: 'İç Navigasyonunuz',
      greeting: 'Tekrar hoş geldiniz',
      assessmentFrom: 'Değerlendirme tarihi',
      lifeDirectionMetrics: 'Yaşam Yönü Metrikleri',
      todaysFocus: 'Bugünün Odağı',
      quickActions: 'Hızlı İşlemler',
    },
    // Dashboard & Navigation
    nav: {
      aiCoach: 'AI Koç',
      theINN: 'Kaynak Merkezi',
      integrate: 'Entegrasyon',
      goals: 'Hedefler',
      morning: 'Sabah',
      evening: 'Akşam',
      progress: 'İlerleme',
      settings: 'Ayarlar',
      logout: 'Çıkış',
      dashboard: 'Panel',
      back: 'Geri',
      backToDashboard: 'Panoya Dön',
    },
    // Morning Guidance
    morning: {
      title: 'Günaydın',
      subtitle: 'Bugün için rehberliğiniz',
      mantraTitle: 'Günlük Mantra',
      todayFocus: 'Bugünkü Odak',
      actionableSteps: 'Eyleme Geçirilebilir Adımlar',
      yourSunMap: 'Güneş Haritanız',
      goToDashboard: 'Panoya Git',
      failed: 'Sabah rehberliği yüklenemedi',
    },
    // Evening Check-In
    evening: {
      title: 'Akşam Kontrolü',
      subtitle: 'Bugünü değerlendirin ve yarın için niyetler belirleyin',
      winsLabel: 'Bugünkü kazanımlarınız nelerdi?',
      winsHint: 'İlerlemenizi kutlayın, ne kadar küçük olursa olsun',
      winsPlaceholder: 'Gösterdim, denedim, öğrendim...',
      improveLabel: 'Yarın neyi daha iyi yapabilirsiniz?',
      improveHint: 'Gelişim dürüst yansıtmada gerçekleşir',
      improvePlaceholder: 'Yarın odaklanacağım...',
      submit: 'Kontrolü Tamamla',
      submitting: 'Düşünülüyor...',
      restWell: 'İyi dinlenin. Yarın yeni bir bölümdür.',
      returnDashboard: 'Panoya Dön',
      saved: 'Akşam kontrolü kaydedildi!',
      failed: 'Kontrol kaydedilemedi',
    },
    // Coaching
    coaching: {
      title: 'AI Koçunuz',
      welcomeMessage: "Ben AI koçunuzum. Önceliklerinizi, alışkanlıklarınızı ve ilerlemenizi biliyorum. Hedefleriniz hakkında bana her şeyi sorun veya aklınızdakileri paylaşın.",
      placeholder: 'Hedefleriniz, ilerlemeniz veya sonraki adımınız hakkında sorun...',
      errorResponse: "Bağlantı sorunu yaşıyorum. Lütfen tekrar deneyin.",
      failed: 'Yanıt alınamadı',
    },
    // Weekly Goals Check-In
    goalsCheckin: {
      title: 'Haftalık Hedef Kontrolü',
      subtitle: 'Belirli öncelikleriniz ve alışkanlıklarınızdaki ilerlemenizi takip edin',
      prioritiesTitle: '3 Önceliğiniz - İlerlemenizi Puanlayın (0-100)',
      notesPlaceholder: 'İlerleme veya engeller hakkında notlar...',
      habitsTitle: '3 Haftalık Alışkanlığınız - Tamamladınız mı?',
      saveProgress: 'İlerlemeyi Kaydet',
      saving: 'Kaydediliyor...',
      success: 'Haftalık kontrol tamamlandı!',
      failed: 'Kontrol kaydedilemedi',
      loadFailed: 'Hedefler yüklenemedi',
    },
    // Check-In (Weekly)
    checkin: {
      title: 'Haftalık Kontrol',
      subtitle: 'İlerlemenizi takip etmek için her alanı yeniden puanlayın',
      reflectionLabel: 'Haftalık Düşünce (İsteğe Bağlı)',
      reflectionPlaceholder: 'Bu hafta ne değişti? Herhangi bir içgörü?',
      complete: 'Kontrolü Tamamla',
      updating: 'Güncelleniyor...',
      success: 'Haftalık kontrol tamamlandı!',
      failed: 'Kontrol gönderilemedi',
    },
    // Progress
    progress: {
      title: 'İlerleme Yolculuğunuz',
      assessmentsCompleted: 'değerlendirme tamamlandı',
      assessmentsCompletedPlural: 'değerlendirme tamamlandı',
      chartTitle: 'Zaman İçinde Ana Alanlar',
      historyTitle: 'Değerlendirme Geçmişi',
      initialAssessment: 'İlk Değerlendirme',
      weeklyCheckin: 'Haftalık Kontrol',
      failed: 'İlerleme geçmişi yüklenemedi',
    },
    // Settings
    settings: {
      title: 'Günlük Kontrol Ayarları',
      morningTitle: 'Sabah Güneş Haritası Hatırlatıcısı',
      morningDesc: 'Günlük odağınızı, eylem adımlarınızı ve kişiselleştirilmiş mantranızı alın',
      morningTime: 'Sabah Saati',
      eveningTitle: 'Akşam Kontrolü',
      eveningDesc: 'Kazanımlarınızı değerlendirin ve yarın için niyetler belirleyin',
      eveningTime: 'Akşam Saati',
      notificationMethod: 'Bildirim Yöntemi',
      inApp: 'Uygulama İçi',
      email: 'E-posta',
      both: 'Her İkisi',
      savePreferences: 'Tercihleri Kaydet',
      saving: 'Kaydediliyor...',
      saved: 'Tercihler kaydedildi!',
      failed: 'Tercihler kaydedilemedi',
    },
    // INtegrate
    integrate: {
      title: 'Entegrasyon',
      subtitle: 'Güneş Haritası alanlarındaki ilerlemenizi otomatik olarak takip etmek için uygulamalarınızı bağlayın',
      connectedApps: 'Bağlı Uygulamalar',
      tracks: 'Takip Eder',
      comingSoon: 'Yakında',
      connect: 'Bağla',
      disconnect: 'Bağlantıyı Kes',
      connectFailed: 'Uygulama bağlanamadı',
      disconnectFailed: 'Uygulama bağlantısı kesilemedi',
      disconnected: 'Uygulama bağlantısı kesildi',
      placeholder: 'Tam OAuth entegrasyonu yakında. Mevcut bağlantılar özelliği göstermek için yer tutuculardır.',
      loadFailed: 'Uygulamalar yüklenemedi',
    },
    // The INN
    inn: {
      title: 'Kaynak Merkezi',
      subtitle: 'Her yaşam alanı için seçilmiş öğretmenler, pratikler ve kaynaklar',
      domains: 'Alanlar',
      all: 'hepsi',
      book: 'kitap',
      teacher: 'öğretmen',
      practice: 'pratik',
      course: 'kurs',
      tool: 'araç',
      learnMore: 'Daha Fazla',
      noResources: 'Bu filtre için kaynak bulunamadı',
      growingLibrary: 'Kaynak Merkezi büyüyen bir kütüphane. Düzenli olarak daha fazla kaynak ekleniyor.',
      contribute: 'Katkı sağlamak ister misiniz? Öğretmen, pratik veya kaynak önermek için ulaşın.',
      loadFailed: 'Alanlar yüklenemedi',
      resourcesFailed: 'Kaynaklar yüklenemedi',
      recommendedForYou: 'Sizin İçin Öneriler',
      focusAreas: 'Odak alanlarınıza göre',
    },
    // Sun Map Component
    sunMap: {
      title: 'Güneş Haritanız',
      export: 'Dışa Aktar',
      share: 'Paylaş',
      downloadSuccess: 'Güneş Haritası indirildi!',
      downloadFailed: 'Güneş Haritası dışa aktarılamadı',
      shareSuccess: 'Başarıyla paylaşıldı!',
      linkCopied: 'Link panoya kopyalandı!',
      shareFailed: 'Paylaşım başarısız',
      solarIdeal: 'Güneş İdeali',
      currentPattern: 'Mevcut Örüntü',
      previous: 'Önceki',
    },
    // AI Guidance Card
    aiGuidance: {
      title: 'İç Rehberiniz',
      activeArchetypes: 'Aktif Arketipler',
      weeklyFocus: 'Bu Haftanın Odağı',
      priorities: '30 Günlük Öncelikler',
      weeklyHabits: 'Haftalık Alışkanlıklar',
    },
    // Dictation
    dictation: {
      recording: 'Kaydediliyor...',
      processing: 'İşleniyor...',
      tapToSpeak: 'Konuşmak için dokunun',
      error: 'Ses girişi başarısız',
    },
    // Common
    common: {
      loading: 'Yükleniyor...',
      back: 'Geri',
      backToDashboard: 'Panoya Dön',
      save: 'Kaydet',
      cancel: 'İptal',
      submit: 'Gönder',
    },
  },
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

// Turkish-safe uppercase function
export const toUpperCase = (text, language) => {
  if (!text) return '';
  return text.toLocaleUpperCase(language === 'tr' ? 'tr-TR' : 'en-US');
};
